import React from 'react'
import SharedUserItem from './SharedUserItem'

const SharedWithUsersList = ({ sharedList, setUsersList, showOptions }) => {
    return sharedList.map(sharedItem => <SharedUserItem sharedItem={sharedItem} setUsersList={setUsersList} showOptions={showOptions}/>)
}

export default SharedWithUsersList